export default function sortByEndDate(lhs, rhs) {
  // If either side is missing both start date and end date, make sure it is last
  if (!lhs.endDate && !lhs.startDate) {
    return 1;
  }
  if (!rhs.endDate && !rhs.startDate) {
    return -1;
  }
  // If both are current, sort by start date
  if (!lhs.endDate && !rhs.endDate) {
    return rhs.startDate.localeCompare(lhs.startDate);
  }
  // If one is current and the other is not, make sure the current one is first
  if (lhs.endDate && !rhs.endDate) {
    return 1;
  }
  if (!lhs.endDate && rhs.endDate) {
    return -1;
  }
  // Sort by most recent end date
  return rhs.endDate.localeCompare(lhs.endDate);
}
